import {ProgressBarView} from './ProgressBarView'

import {PIXI} from '@colonist/pixi'

export class RankedProgressBarView extends ProgressBarView {
    private readonly borderSize: number
    constructor(width: number, height: number, container: PIXI.Container, borderSize: number) {
        super(width, height, container)
        this.borderSize = borderSize
    }
    draw() {
        const borderRadius = 5

        this.clear()

        let percentage = this.percentage
        if(percentage < 0) percentage = 0
        if(percentage > 1) percentage = 1

        this.lineStyle(this.borderSize, this.borderColor, 1)
        this.beginFill(this.emptyColor, 0.75)
        this.drawRoundedRect(0, 0, this.size.width, this.size.height, borderRadius)
        this.endFill()

        this.lineStyle(this.borderSize, this.borderColor, 1)
        this.beginFill(this.fillColor)
        this.drawRoundedRect(0, 0, this.size.width * percentage, this.size.height, borderRadius)
        this.endFill()
    }
}
